var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#F2F6FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8248 26.0254L22.6998 29.9004C22.8831 30.0837 22.9748 30.3171 22.9748 30.6004C22.9748 30.8837 22.8831 31.1171 22.6998 31.3004C22.5165 31.4837 22.2831 31.5754 21.9998 31.5754C21.7165 31.5754 21.4831 31.4837 21.2998 31.3004L16.6998 26.7004C16.5998 26.6004 16.529 26.4921 16.4873 26.3754C16.4456 26.2587 16.4248 26.1337 16.4248 26.0004C16.4248 25.8671 16.4456 25.7421 16.4873 25.6254C16.529 25.5087 16.5998 25.4004 16.6998 25.3004L21.2998 20.7004C21.4998 20.5004 21.7373 20.4004 22.0123 20.4004C22.2873 20.4004 22.5248 20.5004 22.7248 20.7004C22.9248 20.9004 23.0248 21.1379 23.0248 21.4129C23.0248 21.6879 22.9248 21.9254 22.7248 22.1254L18.8248 26.0254ZM33.1748 25.9754L29.2998 22.1004C29.1165 21.9171 29.0248 21.6837 29.0248 21.4004C29.0248 21.1171 29.1165 20.8837 29.2998 20.7004C29.4831 20.5171 29.7165 20.4254 29.9998 20.4254C30.2831 20.4254 30.5165 20.5171 30.6998 20.7004L35.2998 25.3004C35.3998 25.4004 35.4706 25.5087 35.5123 25.6254C35.554 25.7421 35.5748 25.8671 35.5748 26.0004C35.5748 26.1337 35.554 26.2587 35.5123 26.3754C35.4706 26.4921 35.3998 26.6004 35.2998 26.7004L30.6998 31.3004C30.4998 31.5004 30.2665 31.5962 29.9998 31.5879C29.7331 31.5796 29.4998 31.4754 29.2998 31.2754C29.0998 31.0754 28.9998 30.8379 28.9998 30.5629C28.9998 30.2879 29.0998 30.0504 29.2998 29.8504L33.1748 25.9754Z",
    fill: "#5A6471"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.4adb853c4b682a567c7eb2cd6afcfb69.svg";
export { ForwardRef as ReactComponent };